/* eslint-disable no-underscore-dangle */
import { useToast } from '@chakra-ui/toast';
import { AxiosResponse } from 'axios';
import React, { useEffect, useState } from 'react';
import DataTableComponent, { ColumnHeaders, getRowsPerPage } from '../../components/DataTable';
import { IDataIntegrationSource } from '../../dtos/data-integration-source';
import { IGetDataProps } from '../../dtos/IGetDataProps';
import api from '../../services/api';
import DataIntegrationSourceModal from './DataIntegrationSourceModal';

const DataIntegrationSource = () => {
  const Toast = useToast();
  const [showModal, setShowModal] = useState(false);
  const [actionModal, setActionModal] = useState<'VIEW' | 'EDIT' | 'DEFAULT'>('DEFAULT');
  const [dataId, setDataId] = useState('');
  const [dataIntegrationSourceList, setDataIntegrationSourceList] = useState<IDataIntegrationSource[]>([]);
  const [filterValue, setFilterValue] = useState<string>();
  const [rowsPerPage] = useState(getRowsPerPage());
  const [currentPage, setCurrentPage] = useState(1);
  const [allRows, setAllRows] = useState(0);
  const [headers, setHeaders] = useState<ColumnHeaders[]>([]);
  const [isLoading, setLoading] = useState<boolean>(true);
  const [sortable, setSsortable] = useState<string>();


  const getData = async ({ filter, sort, page, offset, limit = rowsPerPage }: IGetDataProps) => {
    try {
      setLoading(true);
      setCurrentPage(page || 1);
      setFilterValue(filter);
      setSsortable(sort);
      const query: string[] = [];
      if (filter) {
        query.push(`q=${filter}`);
      }
      if (sort) {
        query.push(`sort=${sort}`);
      }
      if (offset) {
        query.push(`skip=${offset}`);
      }
      if (limit) {
        query.push(`limit=${limit}`);
      }

      setDataIntegrationSourceList([]);
      setAllRows(0);
      const response: AxiosResponse = await api.get(`/dataintegration/list${query.length > 0 ? `?${query.join('&')}` : ''}`);
      if (response && response.data) {
        const docs: IDataIntegrationSource[] = response.data.rows || []
        setDataIntegrationSourceList(docs);
        setAllRows(response.data.allRows);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const closeForm = (reload = false) => {
    setActionModal('DEFAULT');
    setDataId('');
    setShowModal(false);
    if (reload) {
      getData({});
    }
  };

  useEffect(() => {
    setHeaders([
      { text: 'Código', value: 'code', align: 'center', sortable: true },
      { text: 'Nome', value: 'name', alignHeader: 'center', sortable: true },
      { text: 'Ativo', value: 'active', type: 'boolean', align: 'center', sortable: true },
    ]);
    getData({});
  }, []);

  return (
    <>
      {showModal ? <DataIntegrationSourceModal dataId={dataId} action={actionModal} onCloseForm={closeForm} /> : null}
      <DataTableComponent
        isLoading={isLoading}
        headers={headers}
        itens={dataIntegrationSourceList}
        filter={filterValue}
        paginationOptions={{
          allItems: allRows,
          itemsPerPage: rowsPerPage,
          page: currentPage,
        }}
        tableSync={(filter, sort, page, offset, limit) => {
          getData({ filter, sort, page, offset, limit });
        }}
        newItem={() => {
          setShowModal(true);
          setActionModal('EDIT');
        }}
        itemActionEdit={(item: IDataIntegrationSource) => {
          // console.log(item.name);
          setDataId(item._id);
          setShowModal(true);
          setActionModal('EDIT');
        }}
        itemActionView={(item: IDataIntegrationSource) => {
          setDataId(item._id);
          setActionModal('VIEW');
          setShowModal(true);
        }}
        columnSortable={sortable}
      />
    </>
  );
};

export default DataIntegrationSource;
